import React from 'react';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../_metronic/_helpers';

export function AddButton(props) {
  return (
    <span className="svg svg-icon cursor-pointer" {...props}>
      <SVG
        uniquifyIDs
        cacheRequests
        src={toAbsoluteUrl('/media/svg/senseworks/add_circle.svg')}
      />
    </span>
  );
}
